import imageUrlBuilder from '@sanity/image-url';

const builder = imageUrlBuilder({ projectId: 'cifo3gax', dataset: 'production' });

export function urlFor(source) {
  return builder.image(source);
}
